import React from 'react';
export function Footer() {
  return <footer className="border-t border-ballet-line bg-white px-4 py-8 text-center" data-id="element-128" data-mp="32wd2cf6gdjt0">
      <p className="text-sm text-ballet-muted" data-id="element-129" data-mp="3gg0yw2enzvx4">
        © 2026 Ballet Teacher Ready™ — All rights reserved.
      </p>
    </footer>;
}